// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"88dfb350555bc72617cd","655":"799961affb901377fff7"}[chunkId] + ".js";
};